import { useEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * Envoy in the window completely loads before this component even renders hence why a useEffect
 * window load event won't ever fire. If that's the case, we just immediately register the service worker
 */
let windowLoaded = false;
/**
 * Of course, because of nextjs we gotta do an if check on window =.= T.T
 */
if (typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    windowLoaded = true;
  });
}

const loadServiceWorker = () => {
  /**
   * No babel optional chains enabled in storybook's build for some reason
   */
  if (navigator && navigator.serviceWorker) {
    navigator.serviceWorker
      .register('/service-worker.js', {})
      .then(registration => {
        registration.addEventListener('updatefound', () => {
          // This is a good log for troubleshooting
          // eslint-disable-next-line no-console
          console.log('~~~onupdatefound FOUND~~~');
          // updateServiceWorker(registration);
        });
        // This is a good log for troubleshooting
        // eslint-disable-next-line no-console
        console.log('SW registered:', registration);
      })
      .catch(registrationError => {
        // This is a good log for troubleshooting
        // eslint-disable-next-line no-console
        console.log('SW registration failed:', registrationError);
      });
  }
};

export const ServiceWorkerProvider = () => {
  // const updateServiceWorker = () => {
  //   window.location.reload();
  // };

  const location = useLocation();

  useEffect(() => {
    if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
      if (windowLoaded) {
        loadServiceWorker();
      } else {
        window.addEventListener('load', () => {
          loadServiceWorker();
        });
      }
    }
  }, [loadServiceWorker]);

  useEffect(() => {
    /**
     * No babel optional chains enabled in storybook's build for some reason
     */
    if (navigator && navigator.serviceWorker) {
      navigator.serviceWorker
        .getRegistrations()
        .then(registrationsArray => {
          if (registrationsArray.length > 0) {
            return registrationsArray[0].update();
          }
        })
        .catch(registrationError => {
          // This is a good log for troubleshooting
          // eslint-disable-next-line no-console
          console.log('SW update failed:', registrationError);
        });
    }
  }, [location.pathname, location.search]);

  return null;
};
